import axios from 'axios';

// Utility to append token to request headers
// function _appendToken(options) {
//     // Retrieve the soft or hard token from localStorage (or sessionStorage)
//     const softToken = localStorage.getItem("softToken");
//     const hardToken = localStorage.getItem("hardToken");

//     if (softToken) {
//         // Use the soft token (if it exists)
//         if (!options) options = {};
//         if (!options.headers) options.headers = {};
//         options.headers['Authorization'] = `Bearer ${softToken}`;
//     } else if (hardToken) {
//         // Use the hard token if the soft token doesn't exist
//         if (!options) options = {};
//         if (!options.headers) options.headers = {};
//         options.headers['Authorization'] = `Bearer ${hardToken}`;
//     }

//     return options;
// }

function _appendToken(options) {

    const firebaseBaseUrl = process.env.VUE_APP_FIREBASEIO_BASE_URL;

    // Don't attach token for Firebase
    if (options.baseURL && options.baseURL.includes(firebaseBaseUrl)) {
        return options;
    }

    const token = localStorage.getItem("bearer-jwt");
    if (token) {
        if (!options) options = {};
        if (!options.headers) options.headers = {};
        options.headers['Authorization'] = `Bearer ${token}`;
    }
    return options;
}

// Utility function to create an Axios instance with a specified baseURL
const createApiClient = (baseURL) => {
    const instance = axios.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
        },
    });

    // Add interceptors to append token to every request
    instance.interceptors.request.use(
        (config) => _appendToken(config),
        (error) => Promise.reject(error)
    );

    instance.interceptors.response.use(
        (response) => {
            // Return the response if successful
            return response;
        },
        (error) => {
            console.log('APISERVICE ERROR LOG:', error)
            if (error.response) {
                const status = error.response.status;

                // Check for 401 (Unauthorized) or 403 (Forbidden)
                if (status === 401 || status === 403) {
                    console.warn('Token expired or unauthorized access detected.');

                    // Remove token from localStorage
                    localStorage.removeItem('hardToken');
                    localStorage.removeItem('softToken');
                    // logout();

                    console.log("window.vueApp?.config?.globalProperties?.$user",window.vueApp?.config?.globalProperties?.$user)
                    if (window.vueApp?.config?.globalProperties?.$user.value) {
                        window.vueApp.config.globalProperties.$user.value = null
                    } else {
                        console.warn('$user is not defined on vueApp');
                    }


                    if(status === 403){
                        // window.location.href = '/login'; // Replace with your login route
                    }
                    // Optional: Redirect to the login page
                }
            }

            // Reject the error so calling methods can handle it
            return Promise.reject(error);
        }
    );


    return instance;
};

// Define your base URLs
const apiClients = {
    default: createApiClient(process.env.VUE_APP_API_BASE_URL),
    auth: createApiClient(process.env.VUE_APP_API_BASE_URL),
    data: createApiClient(process.env.VUE_APP_FIREBASEIO_BASE_URL),
};

// Export methods for general use
export const get = async (url, options) => {
    return apiClients.default.get(url, _appendToken(options));
};

export const post = async (url, data, options) => {
    return apiClients.default.post(url, data, _appendToken(options));
};

export const put = async (url, data, options) => {
    return apiClients.default.put(url, data, _appendToken(options));
};

export const patch = async (url, data, options) => {
    return apiClients.default.patch(url, data, _appendToken(options));
};

export const deleteRequest = async (url, options) => {
    return apiClients.default.delete(url, _appendToken(options));
};

// Add a helper function to authorize and get token
export const authorize = async (credentials) => {
    try {
        const response = await apiClients.auth.post('/api/authorization/token', credentials);
        // Assuming you get both tokens from the response
        const { softToken, hardToken } = response.data;

        // Save the tokens to localStorage (or sessionStorage)
        sessionStorage.setItem("softToken", softToken);
        localStorage.setItem("hardToken", hardToken);

        return response.data;
    } catch (error) {
        console.error('Authorization failed:', error);
        throw error;
    }
};

export const checkBearer = async () => {
    try {
        const response = await apiClients.default.get('/api/me/authorization/state');
        return response.data;
    } catch (error) {
        console.error('Error checking authorization:', error);
        throw error;
    }
};

export const logout = () => {
    localStorage.removeItem("bearer-jwt");
    console.log('Logged out successfully');
    // window.location.reload();
};

// Export the clients for use in main.js
export default apiClients;
